import { render, staticRenderFns } from "./CompanyHeaderCustomizations.vue?vue&type=template&id=1689ecc5&"
import script from "./CompanyHeaderCustomizations.vue?vue&type=script&lang=js&"
export * from "./CompanyHeaderCustomizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports